import { css } from 'styled-components';
export const BKJThemeToggle = {
    Switch: css ``,
    PurplePillLeft: css ``,
    PurplePillRight: css ``,
    PurpleNoBorderLeft: css ``,
    PurpleNoBorderRight: css ``,
};
//# sourceMappingURL=BKJToggleInput.theme.js.map